var map = {
	"./android-icon.svg": 2250,
	"./app-img.png": 2251,
	"./app-qr-code-bg.png": 2252,
	"./apple-icon.svg": 2253,
	"./contact-bg.png": 2254,
	"./contact-us-bg.jpg": 2255,
	"./qr-bg.png": 2256
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2249;